import React from 'react';
import PropTypes from 'prop-types';

import MoveLibraryModal from './MoveLibraryModal';
import ImportCatalogModal from './ImportCatalogModal/ImportCatalogModal';

const ContentLibraryModals = ({
  visible,
  onCancel,
  selectedFolderKey,
  template,
  catalog,
  refetchTemplates,
  refetchCatalogs,
  catalogIds,
  isCatalog,
  showImportCatalogModal,
  setShowImportCatalogModal,
  addNewChildFromSearch,
  treeData,
  setCheckedCatalogs,
  onKeySelect,
  handleTreeSearch,
  isDashboard,
  isTemplate,
  defaultCatalogSource,
  defaultSaveXmlLink,
  setTreeSearch,
}) => {
  return (
    <>
      {visible && (
        <MoveLibraryModal
          language={template?.language}
          visible={visible}
          onCancel={onCancel}
          template={template}
          catalog={catalog}
          selectedFolderKey={selectedFolderKey}
          refetchTemplates={refetchTemplates}
          refetchCatalogs={refetchCatalogs}
          treeData={treeData}
          catalogIds={catalogIds}
          isDashboard={isDashboard}
          isTemplate={isTemplate}
          isCatalog={isCatalog}
          setCheckedCatalogs={setCheckedCatalogs}
          onKeySelect={onKeySelect}
          addNewChildFromSearch={addNewChildFromSearch}
          handleTreeSearch={handleTreeSearch}
        />
      )}
      {showImportCatalogModal && (
        <ImportCatalogModal
          cancelUploadModal={() => setShowImportCatalogModal(false)}
          showImportCatalogModal={showImportCatalogModal}
          setShowImportCatalogModal={setShowImportCatalogModal}
          treeDataFromProps={treeData}
          refetchCatalogs={refetchCatalogs}
          addNewChildFromSearch={addNewChildFromSearch}
          handleTreeSearch={handleTreeSearch}
          treeData={treeData}
          selectedFolderKey={selectedFolderKey}
          defaultCatalogSource={defaultCatalogSource}
          defaultSaveXmlLink={defaultSaveXmlLink}
          setTreeSearch={setTreeSearch}
        />
      )}
    </>
  );
};

ContentLibraryModals.defaultProps = {
  visible: false,
  isDashboard: false,
  isTemplate: false,
  isCatalog: false,
  selectedFolderKey: '',
  onCancel: () => {},
  refetchTemplates: () => {},
  refetchCatalogs: () => {},
  setCheckedCatalogs: () => {},
  onKeySelect: () => {},
  defaultCatalogSource: 'csv',
  defaultSaveXmlLink: false,
};

ContentLibraryModals.propTypes = {
  visible: PropTypes.bool,
  template: PropTypes.instanceOf(Object),
  catalog: PropTypes.instanceOf(Object),
  isDashboard: PropTypes.bool,
  isTemplate: PropTypes.bool,
  isCatalog: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  selectedFolderKey: PropTypes.string,
  onCancel: PropTypes.func,
  refetchTemplates: PropTypes.func,
  refetchCatalogs: PropTypes.func,
  catalogIds: PropTypes.array,
  showImportCatalogModal: PropTypes.bool,
  setShowImportCatalogModal: PropTypes.func,
  addNewChildFromSearch: PropTypes.func,
  treeData: PropTypes.object,
  setCheckedCatalogs: PropTypes.func,
  onKeySelect: PropTypes.func,
  handleTreeSearch: PropTypes.func,
  defaultCatalogSource: PropTypes.string,
  defaultSaveXmlLink: PropTypes.bool,
  setTreeSearch: PropTypes.func,
};

export default ContentLibraryModals;
